<template>
<div class="flex justify-center w-full pt-28 h-full overflow-y-auto">
        <div class="max-w-screen-2xl w-11/12 px-2 ">
            <div class="flex flex-row flex-wrap -mx-4 justify-center  overflow-y-auto">
                <product-list-item
                    v-for="product in products"
                    :key="product.product_id"
                    :product="product"
                />

                <div class="w-80 m-4"></div>
                <div class="w-80 m-4"></div>
                <div class="w-80 m-4"></div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex'
import ProductListItem from '../../modules/productList/components/productListItem.vue'
export default {
    created(){
        this.$store.dispatch("getProducts")
    },
    components: { ProductListItem },
    computed:{
        ...mapGetters(["products"])
    },
name: "productList"
}
</script>

<style>

</style>